import Module from '../utils/Module';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "../vendors/SplitText.min";
import EventsManager from '../utils/EventsManager';
import CustomEvents from '../utils/CustomEvents';
import ResizeManager from '../utils/ResizeManager';

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

export default class HeroModule extends Module {
  constructor (options) {
    super(options)

    this.canAnim = false;

    this.DOMEl = options.element;
    this.contentText = this.DOMEl.querySelector(".hero-content__title")
    this.contentImage = this.DOMEl.querySelector(".image-container")
    this.contentVideo = this.DOMEl.querySelector('.video-container')
    this.timeline = gsap.timeline().pause();

    this.animComplete = false;

    this.init();
  }

  init () {
    this.splittedTitle = new SplitText(this.contentText,  {type:"words", wordsClass: "split-line"});

    this.splittedTitle.words.forEach(word =>{
      const wrapper = document.createElement('div')
      wrapper.className = 'text-reveal-transform-wrapper'
      word.parentNode.insertBefore(wrapper, word)
      wrapper.appendChild(word);
    });

    this.timeline.to(this.splittedTitle.words, {'opacity': 1,'transform':'rotate(0) translate3d(0,-10px,0)', duration: 0.5 , ease: "power2.out", stagger:0.05})
    this.timeline.to(this.contentImage, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", onComplete:()=>{
      this.animComplete = true;
    }}, '-=0.6');

    this.timeline.to(this.contentVideo, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out", onComplete:()=>{
        this.animComplete = true;
      }}, '-=0.6');

    ResizeManager.bind("hero-intern-resize", this.onResize.bind(this));


    EventsManager.on( CustomEvents.commons.readyToStartAnims, ()=>{
      this.canAnim = true;
      this.startAnims();
    });
  }

  startAnims() {
    ScrollTrigger.create({
      trigger: this.DOMEl,
      onEnter: ()=>{
        if(this.canAnim)
          this.timeline.play();
      },
      onEnterBack: ()=>{
        if(this.canAnim)
          this.timeline.play();
      }
    });
  }

  onResize() {
    if(this.animComplete) {
      this.splittedTitle.revert();
    }
  }
}
